import { Component, inject, OnInit } from '@angular/core';
import { MedicalHistoryService } from '../../services/medical-history.service';
import { ActivatedRoute } from '@angular/router';
import { AmplitudeService } from '../../services/amplitude.service';
import { LocaleService } from '../../services/locale.service';
import { MessageNavigationService } from 'src/app/services/message-navigation.service';

@Component({
  selector: 'app-confirmation-sending-hc',
  template: '',
  styles: [''],
  standalone: false
})
export class SendMedicalRecordsComponent implements OnInit {
  private medicalHistoryService = inject(MedicalHistoryService);
  private readonly route = inject(ActivatedRoute);
  private readonly amplitudeService = inject(AmplitudeService);
  private readonly localeService = inject(LocaleService);
  private readonly messageNavigationService = inject(MessageNavigationService);

  errorToSendingEmail = false;

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      const patient = params?.patient;
      const locale = params?.locale;
      if (locale) {
        await this.localeService.use(locale);
      }
      if (!patient) {
        return;
      }
      try {
        const { result } = await this.medicalHistoryService.sendPatientMedicalRecords(params.patient);
        if (result) {
          this.amplitudeService.logEvent('medical_records_accepted_and_email_sent');
        }
        this.messageNavigationService.goToMessage('medical_records_email_greeting');
      } catch (error) {
        this.errorToSendingEmail = true;
        if (error.error.status === 401) {
          this.messageNavigationService.goToMessage('medical_records_token_expired_message');
          return;
        }
        this.messageNavigationService.goToMessage(error?.error?.message);
      }
    });
  }
}
